module.exports = __webpack_public_path__ + "static/media/questionnaire.26fb2ab5.svg";